import React, { useState } from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';
import DropDown from '../Ui/DropDown';

const UpdateStatusModal = ({ t, showModal, loading, handleCancel, paymentId, updateStatus, handleOk }) => {
 
    const [selectType, setSelectType] = useState('');
    const [reason, setReason] = useState('');
    const [errMsg, setErrmsg] = useState('');

    const handleSubmit = () => {
        if(selectType?.value && reason) {
            const payload = {
                id: paymentId,
                status: selectType.value,
                reason
            }
            handleOk(payload);
        } else {
            setErrmsg("Please Fill All the Fields!")
        }
    }

    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.additionalPayment.updateAdditionalPayment")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.changeStatus")}</label>
                                <DropDown value={selectType} placeholder={"Select Status"} options={updateStatus} onChange={e => {setSelectType(e); setErrmsg('')}} />
                            </div>
                            <div>
                                <p className="text-primary mb-2" >{t("jobsManagement.infoJob.additionalPayment.reason")}</p>
                                <textarea onChange={e => {setReason(e.target.value); setErrmsg('')}} className="w-100 p-2" rows="4" placeholder={t("jobsManagement.infoJob.additionalPayment.enterReason")} />
                            </div>
                            {errMsg && <p className='text-center text-danger'>{errMsg}</p>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading} onClick={handleCancel}>{t("jobsManagement.infoJob.additionalPayment.cancel")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading} onClick={()=> {handleSubmit()}}>
                                {t("jobsManagement.infoJob.additionalPayment.submit")} {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default UpdateStatusModal;
